<script setup>
  import { computed } from 'vue';
  import SelectOptionV4 from '../SelectOptionV4';
  import { useMainStore } from '../../store/index.js';
  import { useWindowWidth } from '../../composables/windowWidth.js';
  import '../../styles/configurator-section.css';
  import '../../styles/configurator-selection.css';

  const store = useMainStore();

  const emit = defineEmits(['select']);

  const props = defineProps({
    items: {
      type: Object,
      default: null,
    },
    images: {
      type: Object,
      default: null,
    },
  });

  const { isSmall } = useWindowWidth(1000);

  const safetyOptions = computed(() => {
    const groupSize = 2;
    const options = [];
    if (props.items) props.items.forEach((item) => options.push(item));
    return Array.from({ length: Math.ceil(options.length / groupSize) }, (_, i) => options.slice(i * groupSize, i * groupSize + groupSize));
  });

  const select = (option) => emit('select', { option, type: props.type });
</script>

<template>
  <section
    v-if="props.items"
    id="safety"
    class="configurator-section"
  >
    <h2>{{ $i18n('safetyHeaderTitle') }}</h2>
    <template v-if="safetyOptions.length">
      <template
        v-for="(packageGroup, index) in safetyOptions"
        :key="index"
      >
        <div class="configurator-selection__options">
          <template
            v-for="(packageObject, index2) in packageGroup"
            :key="index2"
          >
            <SelectOptionV4
              v-for="option in packageObject.options"
              :key="option.id"
              :option="option"
              :selected="store.selected.safety[packageObject.id]?.id == option.id"
              :show-description="true"
              :show-information="true"
              :single-option="packageObject.options?.length === 1"
              :style-object="isSmall ? { width: '420px' } : {}"
              @click="select(option)"
            />
          </template>
        </div>
      </template>
    </template>
  </section>
</template>

<style scoped>
  .configurator-section__image {
    display: flex;
    flex-direction: row;
    justify-content: center;
    gap: 2em;
    max-width: 100%;
  }
  .configurator-section__image img {
    width: 40%;
  }
  .configurator-selection__options {
    gap: var(--sdds-spacing-layout-32);
  }
  @media only screen and (max-width: 1000px) {
    .configurator-section__image {
      gap: 1em;
      max-width: 90%;
    }
    .configurator-selection__options {
      flex-direction: column;
      align-items: center;
      padding-bottom: var(--sdds-spacing-layout-8);
    }
  }
  @media only screen and (max-width: 500px) {
    .configurator-section__image {
      flex-direction: column;
      align-items: center;
    }
    .configurator-section__image img {
      width: 90%;
    }
  }
</style>
